import React, { useEffect } from 'react';
import styles from './consentPageContent.module.scss';
import * as i18next from 'i18next';
import ITermDto from '../../domain/dto/ITermDto';

interface IProps {
  t: i18next.TFunction;
  bankName: string;
  isImplicit?: boolean;
  terms?: ITermDto;
}

const getSharingInformation = (
  t: i18next.TFunction,
  bankName: string,
  isImplicit: boolean | undefined,
  terms: ITermDto | undefined
) => {
  if (terms && terms.termParameters?.description) {
    return `${t<string>(terms.termParameters.description, {
      bankName: bankName
    })}`;
  }

  if (isImplicit) {
    return `${t("To continue, we'll connect you securely to your bank.")}`;
  }

  return '';
};

const getTitle = (
  t: i18next.TFunction,
  bankName: string,
  isImplicit: boolean | undefined,
  terms: ITermDto | undefined
) => {
  if (terms && terms.termParameters?.header) {
    return `${t<string>(terms.termParameters.header, {
      bankName: bankName
    })}`;
  }

  if (isImplicit) {
    return `${t<string>('Connect your {{bankName}} account', {
      bankName: bankName
    })}`;
  }

  return `${t<string>('Provide consent')}`;
};

const CreateConsentPageContent: React.FC<IProps> = (props: IProps) => {
  const { t, bankName, isImplicit, terms } = props;
  const sharingInformation = getSharingInformation(t, bankName, isImplicit, terms);

  const title = getTitle(t, bankName, isImplicit, terms);
  const additionalSharingInformation = `${t<string>(
    'Please ensure you have your bank details at hand before proceeding. Atto will not be able to see any of your login details.'
  )}`;

  useEffect(() => {
    if (window.hj) {
      window.hj('tagRecording', ['Screen: Create Consent']);
    }
  }, []);

  return (
    <div data-testid="consent-page-content">
      <div className="mb-6">
        <h1
          className="text-md md:text-lg text-primary-2 uppercase font-bold "
          data-testid="consent_page_introduction_title"
        >
          {title}
        </h1>
        <p className="text-base" data-testid="consent_page_introduction_paragraph">
          {sharingInformation}
        </p>
        {isImplicit && <p className={styles.additionalParagraph}>{additionalSharingInformation}</p>}
      </div>
    </div>
  );
};

export default CreateConsentPageContent;
